module.exports = __webpack_public_path__ + "img/2.34100a25.jpg";